import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CustomRoutes, ICustomRoute } from '../interfaces/i-custom-route';
import { Route } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  /** 
   * Subject used to update the page title displayed in the toolbar.
   * Emits the current page title as a string.
   */
  private readonly pageTitleSubject$ = new BehaviorSubject<string>("Home");

  /** 
   * Observable that components can subscribe to in order to receive page title updates.
   */
  readonly pageTitle$ = this.pageTitleSubject$.asObservable();
  constructor() { }

  /**
   * Converts a given date input (Date object or string) to milliseconds since the Unix epoch.
   * @param dateInput Date object or string in various formats (e.g., "MM/DD/YYYY", "DD-MM-YYYY", "YYYY/MM/DD", etc.)
   * @returns 
   */
  DateToMilliseconds(dateInput: Date | string): number {
    let date: Date
  
    if (dateInput instanceof Date) 
    {
      date = dateInput
    } 
    else 
    {
      const dateString = dateInput.toString().trim()
  
      date = new Date(dateString)
  
      if (isNaN(date.getTime())) 
      {
        const ddmmyyyyMatch = dateString.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);

        if (ddmmyyyyMatch) 
        {
          const [, day, month, year] = ddmmyyyyMatch;

          date = new Date(Number.parseInt(year), Number.parseInt(month) - 1, Number.parseInt(day));
        }
        else 
        {
          const ddmmyyMatch = dateString.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2})$/);

          if (ddmmyyMatch) 
          {
            const [, day, month, year] = ddmmyyMatch;

            const fullYear = Number.parseInt(year) + (Number.parseInt(year) > 50 ? 1900 : 2000);

            date = new Date(fullYear, Number.parseInt(month) - 1, Number.parseInt(day));
          }
        }
      }
    }
  
    if (isNaN(date.getTime())) 
    {
      console.error(`Invalid date format: ${dateInput}`);
      return -1;
    }

    return date.getTime();
  }

  /**
   * Updates the page title in the toolbar based on the given route configuration.
   * If no name is provided, it defaults to "Home".
   * 
   * @param routeConfig - The custom route configuration object containing a page name.
   */
  UpdatePageTitle(routeConfig: Route | null): void 
  {
    let customRoute = routeConfig as ICustomRoute;

    if (customRoute?.name) 
    {
      this.pageTitleSubject$.next(customRoute.name);
    } 
    else 
    {
      this.pageTitleSubject$.next("Home");
    }
  }
}
